import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import PetDownload from '../pages/AppDownload/PetParent';

// Lazy load all pages for better performance and smaller initial bundle size
const Home = lazy(() => import('../pages/MainPage/Parent'));
const AddAppointment = lazy(() => import('../pages/Appointment/AddAppointment'));
const About = lazy(() => import('../pages/MainPage/About'));
const ParentRegistration = lazy(() => import('../pages/Auth/ParentRegister'));
const PrivacyPolicy = lazy(() => import('../pages/MainPage/PrivacyPolicy'));
const TermsAndConditions = lazy(() => import('../pages/MainPage/Termsandconditions'));

export default function AppRoutes() {
  const location = useLocation();

  return (
    <Suspense fallback={<LoadingScreen message="Loading..." />}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/AddAppointment" element={<AddAppointment />} />
        <Route path="/about" element={<About />} />
        <Route path="/parentRegistration" element={<ParentRegistration />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsofservice" element={<TermsAndConditions />} />
                <Route path="/petparent" element={<PetDownload />} />


        {/* Fallback route for any unknown paths */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
